import React from 'react';
import parse from 'html-react-parser';
import Typography from 'components/Typography';
import replaceFunction from './replace';

export interface Props {
  children?: string,
}

const ContentParser:React.FC<Props> = ({ children }) => {
  const tagsIteratedRef = React.useRef<string[]>([]);

  React.useEffect(() => {
    tagsIteratedRef.current = [];
  }, []); // reset ref for Fast Refresh etc

  if (!children) return null;

  const parsed = parse(children, {
    replace: (node) => replaceFunction(node, tagsIteratedRef),
  });

  return (
    <Typography
      className="user-content"
      variant="container"
    >
      {parsed}
    </Typography>
  );
};
export default ContentParser;
